var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { InviteUser } from "../constants/invite_user";
var initialState = {
    status: "idle",
    message: "",
    successMessage: "",
    errorMessage: "",
    pendingInvites: [],
    pendingInvitesStatus: "idle",
};
export default function InviteUserReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case InviteUser.InviteUserToOrganisation:
            return __assign(__assign({}, state), { status: "loading", message: "Sending invite..." });
        case InviteUser.InviteUserToOrganisation_Successful:
            return __assign(__assign({}, state), { status: "success", successMessage: action.payload, errorMessage: "" });
        case InviteUser.InviteUserToOrganisation_Error:
            return __assign(__assign({}, state), { status: "error", errorMessage: action.payload, successMessage: "" });
        case InviteUser.InviteUserToSuperorg:
            return __assign(__assign({}, state), { status: "loading", message: "Sending invite..." });
        case InviteUser.InviteUserToSuperorg_Successful:
            return __assign(__assign({}, state), { status: "success", successMessage: action.payload, errorMessage: "" });
        case InviteUser.InviteUserToSuperorg_Error:
            return __assign(__assign({}, state), { status: "error", errorMessage: action.payload, successMessage: "" });
        case InviteUser.FetchTeamMembers:
            return __assign(__assign({}, state), { status: "loading" });
        case InviteUser.FetchTeamMembers_Successful:
            return __assign(__assign({}, state), { status: "success" });
        case InviteUser.FetchTeamMembers_Error:
            return __assign(__assign({}, state), { status: "error", errorMessage: action.payload });
        case InviteUser.ClearInviteMessage:
            return __assign(__assign({}, state), { message: "", successMessage: "", errorMessage: "", status: "idle" });
        case InviteUser.FetchPendingInvites:
            return __assign(__assign({}, state), { pendingInvitesStatus: "loading" });
        case InviteUser.FetchPendingInvites_Successful:
            return __assign(__assign({}, state), { pendingInvitesStatus: "success", pendingInvites: action.payload });
        case InviteUser.FetchPendingInvites_Error:
            return __assign(__assign({}, state), { pendingInvitesStatus: "error", pendingInvites: [] });
        case InviteUser.RevokeInvite:
            return __assign(__assign({}, state), { pendingInvitesStatus: "loading" });
        case InviteUser.RevokeInvite_Successful:
            return __assign(__assign({}, state), { pendingInvitesStatus: "success", pendingInvites: state.pendingInvites.filter(function (invite) { return invite.token !== action.token; }) });
        case InviteUser.RevokeInvite_Error:
            return __assign(__assign({}, state), { pendingInvitesStatus: "error" });
        case InviteUser.ResendInvite:
            return __assign(__assign({}, state), { pendingInvitesStatus: "loading" });
        case InviteUser.ResendInvite_Successful:
            return __assign(__assign({}, state), { pendingInvitesStatus: "success" });
        case InviteUser.ResendInvite_Error:
            return __assign(__assign({}, state), { pendingInvitesStatus: "error" });
        default:
            return state;
    }
}
